let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("47fIw")).then(() => parcelRequire('3lIA3'));